type TerminalPlanStep = { status: string };

type TerminalPlanLike = {
  status: string;
  steps: TerminalPlanStep[];
};

/** If every step is done but status is still paused/in_progress, treat as completed. */
export function normalizeTerminalPlanStatus<T extends TerminalPlanLike>(plan: T): T {
  const allSucceeded = plan.steps.length > 0 && plan.steps.every((s) => s.status === "completed");
  if (allSucceeded && (plan.status === "paused" || plan.status === "in_progress")) {
    return { ...plan, status: "completed" } as T;
  }
  return plan;
}

export { resolvePlanStepIndex as resolvePlanCurrentStepIndex } from "../../../src/shared/resolvePlanStepIndex";
